import { API_BASE_PATH } from '../../Shared/constants';

export const INITIALIZE_URL = `${API_BASE_PATH}/SendOptimizer/initialize`;
export const GET_METADATA_URL = `${API_BASE_PATH}/Journeys/{journeyId}/metadata/{buID}`;



// WEBPACK FOOTER //
// ./src/Root/constants/index.js